<template>
  <div>
    <el-scrollbar style="overflow-x: hidden;">

       <el-header v-show="contentTitle.length > 0" style="width: 100%;height: 10%;">
         <div class="body-header-div">
            <span style="font-size: 22px; font-weight: 550; line-height: 60px; text-align: left; margin-left: 0px;">
            {{contentTitle}}
            </span>
            <p style="margin-left: 0px">
              更新时间：{{contentUpdateTime}}
            </p>
          </div>
       </el-header>

      <div class="body-html">
        <div v-show="content.length <= 0">
          <p style="font-size: 30px; line-height: 74vh; text-align: center; color: #909399; ">
            暂无内容
          </p>
        </div>
        <div id="app" class="ql-snow" v-cloak>
          <div v-show="content.length > 0"
               style="margin-left: 25px; height: 100%; margin-right: 25px; overflow-x: hidden"
               class="ql-editor" id="msg"
               v-html="content"></div>
        </div>
      </div>

      <el-footer width="100%" height="5%" style="background: #f9fafa">
        <div class="body-footer-div">
          <a @click="updatePage(beforePageColumnId)"
             class="footer-a-page"
             style="float: left;margin-left: 1px"
             v-show="beforePageTitle.length > 0">
            {{"< 上一篇："+beforePageTitle}}
          </a>
          <a @click="updatePage(afterPageColumnId)"
             class="footer-a-page"
             style="float: right;margin-right: 5px"
             v-show="afterPageTitle.length > 0">
            {{"下一篇："+afterPageTitle+" >"}}
          </a>
        </div>
      </el-footer>


    </el-scrollbar>
  </div>
</template>

<script>

import { Bus } from '../js/bus.js'
import {
  docCenterCmsGetByColumnId,
} from "@/api/doccenter/doccenter.js";
import {Loading} from "element-ui"


export default {
  name: "document-center-body",

  data() {
    return {
      column: {},
      content: "",
      contentTitle: "",
      contentUpdateTime: "",
      beforePageTitle: "",
      afterPageTitle: "",
      beforePageColumnId: "",
      afterPageColumnId: "",
    }
  },

  created() {
    Bus.$on('docCenterCmsGetByColumnId',res => {   //两个参数，一个是方法名，一个是要调用的方法
      this.docCenterCmsGetByColumnId(res)
    })
  },

  methods: {
    docCenterCmsGetByColumnId(columnId) {
      let loadingInstance = Loading.service({
        fullscreen: true,
        lock: true,
        background: "rgba(255,255,255,.5)",
        customClass: "light-loading"
      });
      this.contentTitle = "";
      // this.content = "";
      this.updateTime = "";
      this.beforePageTitle = "";
      this.afterPageTitle = "";
      docCenterCmsGetByColumnId({"columnId": columnId}).then(res => {
        const resColumn = res.data.cusCmsColumn;
        this.column = resColumn;
        if (resColumn != null && resColumn != undefined) {
          this.content = this.showHtml(resColumn.content);
          this.contentTitle = resColumn.columnName
          this.contentUpdateTime = resColumn.updateTime
          if (resColumn.updateTime == "" || resColumn.updateTime == undefined || resColumn.updateTime == null) {
            this.contentUpdateTime = resColumn.createTime
          }
          if (resColumn.beforePageColumnId != null && resColumn.beforePageColumnId != undefined) {
            this.beforePageTitle = resColumn.beforePageTitle;
            this.beforePageColumnId = resColumn.beforePageColumnId;
          }
          if (resColumn.afterPageColumnId != null && resColumn.afterPageColumnId != undefined) {
            this.afterPageTitle = resColumn.afterPageTitle;
            this.afterPageColumnId = resColumn.afterPageColumnId;
          }
        }
      }).catch(err => {
        loadingInstance.close()
      }).finally(() => {
        loadingInstance.close()
      })
    },
    updatePage(columnId) {
      this.$emit('changeCurrentColumnId',columnId)
      this.docCenterCmsGetByColumnId(columnId);
    },
    showHtml(str) {
      return str
          .replace(str ? /&(?!#?\w+;)/g : /&/g, '&amp;')
          .replace(/&amp;nbsp;/g,"")
          .replace(/&lt;/g,"<")
          .replace(/&gt;/g,">")
          .replace(/&quot;/g,"\"")
          .replace(/&#39;/g, "\'")
          .replace(/<img/g, "<img style='max-width:100%;height:auto;'")
    },
  }
}
</script>

<style lang="scss" scoped>
  @import '../css/document-body-main';
  .footer-a-page {
    color: black;
    line-height: 50px;
    font-size: 13px;
    cursor: pointer;
  }
  .footer-a-page:hover {
    color: #3f7bf9;
  }
  .body-header-div {
    border-bottom: 1px solid #e9e9e9;
    margin-bottom: 20px;
    padding-bottom: 20px;
  }
  .body-footer-div {
    border-top: 1px solid #e9e9e9;
    height: 0px;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .body-html{
    width: 100%;
    min-height: 63vh;
  }
</style>
